import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Custom components
import TableUnitCell from './TableUnitCell';
import TableStatusCell from './TableStatusCell';
import TableTasksCell from './TableTasksCell';
import TableAssignmentCell from './TableAssignmentCell';
import TableTurnTypeCell from './TableTurnTypeCell';
import Utils from '../../../Services/Utils';

let moment = require('moment');

// Styles
import './style.scss';

export const CURRENT_TASK = 0;
export const NEXT_TASK = 5;

const MakeReadyBoardTable = ({ data, updateSort }) => {
  // Set states vars
  const [sortField, setSortField] = useState({ id: null, field: null });
  const [sortOrder, setSortOrder] = useState(1);
  const [workflowInstances, setWorkFlowsInstances] = useState([]);

  const headerModel = [
    {
      id: "unit",
      label: "Unit",
      field: "unit",
      ordering: "unit_label",
      sortable: true,
      render: (record) => <TableUnitCell unitNumber={record.unit} building={record.building ? record.building : ''} unitType={record.unit_type} />
    },
    {
      id: "status",
      label: "Status",
      field: "status",
      ordering:'unit__turn_status',
      sortable: true,
      render: (record) => <TableStatusCell status={record.status ? record.status : 0} />
    },
    {
      id: "move_in",
      label: "Move In",
      field: "move_in_date",
      ordering: "unit_move_in_date",
      sortable: true,
      render: (record) => (
        <div>
          {!Utils.isNull(record.move_in_date) ? moment(record.move_in_date, 'YYYY/MM/DD').format('YYYY/DD/MM') : ''}
        </div>
      )
    },
    {
      id: "exp_comp",
      label: "Exp Comp",
      field: "exp_comp",
      ordering:'expected_completion_date',
      sortable: true,
      render: (record) => (
        <div>
          {!Utils.isNull(record.exp_comp) ? moment(record.exp_comp, 'YYYY/MM/DD').format('YYYY/DD/MM') : ''}
        </div>
      )
    },
    {
      id: "turn_type",
      label: "Turn Type",
      field: "turn_type",
      ordering: "workflow__unit_turn_type",
      sortable: true,
      render: (record) => <TableTurnTypeCell turn_type={record.turn_type ? record.turn_type.toString() : ''} />
    },
    {
      id: "current_Task",
      label: "Current Task",
      field: "tasks",
      ordering: "current_task_name",
      sortable: true,
      render: (record) => <TableTasksCell tasks={record.current_tasks} />
    },
    {
      id: "current_assigned_to",
      label: "Assigned To",
      field: "current_assigned_to",
      ordering: "current_assigned_to",
      sortable: true,
      render: (record) => <TableAssignmentCell tasks={record.current_tasks} />
    },
    {
      id: "next_Task",
      label: "Next Task",
      field: "next_tasks",
      ordering: "next_task_name",
      sortable: true,
      render: (record) => <TableTasksCell tasks={record.next_tasks} />
    },
    {
      id: "next_assigned_to",
      label: "Next Task Assigned To",
      field: "next_assigned_to",
      ordering: "next_assigned_to",
      sortable: true,
      render: (record) => <TableAssignmentCell tasks={record.next_tasks} />
    },
    {
      id: "elapsed_time",
      label: "Elapsed Time",
      field: "days_in_progress",
      ordering: "elapsed_time",
      sortable: true,
    },
  ];


  useEffect(() => {
    const workFlows = [];
        data.forEach(unit => {
          workFlows.push({
            id: unit.id,
            workName: unit.name,
            unit: unit.unit.number,
            building: unit.unit.building,
            status: unit.unit.turn_status,
            move_in_date: unit.move_in_date,
            exp_comp: unit.expected_completion_date,
            turn_type: unit.turn_type,
            current_tasks: unit.current_tasks,
            next_tasks: unit.next_tasks,
            days_in_progress: unit.elapsed_days,
            unit_type: unit.unit.unit_type
          });
    });
    setWorkFlowsInstances(workFlows);
  }, [data]);

  /**
   * Function to order the columns
   */
  const setSort = (id, field, ordering) => {


    if (field !== sortField.field) {
      updateSort(ordering, 1);

      setSortOrder(1);
    } else {
      updateSort(ordering, sortOrder * -1);

      setSortOrder(sortOrder * -1);
    }
    setSortField({ id, field });
  };

  /**
   * Render cell of the body
   */
  const renderTableCell = (workflow, column) => {
    if (column.render && workflow) {
      return column.render(workflow);
    }
    return workflow[column.field]
  }

  /**
   * Render row of the body
   */
  const renderTableRow = (workflow) => {
    return (
      <tr key={workflow.id} className="unit">
        {headerModel.map((column) => {
          return <td key={column.id}>{renderTableCell(workflow, column)}</td>;
        })}
      </tr>
    );
  };

  /**
   * Render header
   */
  const renderTableHeader = () => {
    const headerElements = headerModel.map((item) => {
      return (
        <td key={item.id}>
          <span
            className={classNames({
              sortable: item.sortable,
              'sortable--sort-ascending': sortField.id === item.id && sortOrder === 1,
              'sortable--sort-descending': sortField.id === item.id && sortOrder === -1
            })}
            onClick={() => setSort(item.id, item.field, item.ordering)}>
            {item.label}
          </span>
        </td>
      );
    });

    return (
      <thead>
        <tr>{headerElements}</tr>
      </thead>
    );
  };

  /**
   * Render body
   */
  const renderTableBody = () => {
    let workflowsElements = workflowInstances.map((workflow) => {
      return renderTableRow(workflow);
    });

    return (
      <tbody>
        {workflowsElements}
      </tbody>
    );
  }

  return (
    <div className="MakeReadyBoardTable">
      <table>
        {renderTableHeader()}
        {renderTableBody()}
      </table>
    </div>
  );
};

MakeReadyBoardTable.propTypes = {
  data: PropTypes.array.isRequired,
  updateSort: PropTypes.func
};

export default MakeReadyBoardTable;
